<template>
    <div>
        <!-- Actions -->
        <div class="actions float-right" v-if="feedback.type != 'mark'">

            <button-checkbox button-classes="btn-secondary" v-if="!simulation.remedial && sharing && feedback.type != 'position'"
                v-model="feedback.shared" @change="$emit('share', feedback)">
                    <i class="fas fa-share mr-1"></i> {{ feedback.shared ? $t('feedbacks.shared') : $t('feedbacks.share') }}
            </button-checkbox>

            <badge type="secondary" style="font-size:1.2rem;" v-if="edit">
                <a href="#" class="text-danger mr-2" @click.prevent="$emit('remove', feedback)">
                    <i class="tim-icons icon-simple-remove"></i>
                </a>
                <a href="#" class="text-primary" @click.prevent="$emit('update', feedback)">
                    <i class="tim-icons icon-pencil"></i>
                </a>
            </badge>
        </div>

        <div :style="edit || sharing ? 'min-height:32px;' : ''" v-if="!feedback.timeslot_id">

            <!-- Time -->
            <small class="text-muted pb-2" v-if="feedback.log_time_from && (!learner || feedback.type == 'position')">
                <i class="fas fa-clock mr-1"></i>{{ feedback.log_time_from }}
                <span v-if="feedback.log_time_to"> - {{ feedback.log_time_to }}</span>
            </small>

            <!-- Summary -->
            <h6 class="text-sm" v-if="(preferLearnerSummary || learner) && feedback.learner_summary">
                {{ feedback.learner_summary }}
            </h6>
            <h6 class="text-sm" v-if="!preferLearnerSummary && !learner && feedback.instructor_summary">
                {{ feedback.instructor_summary }}
            </h6>

            <!-- Position -->
            <slot name="position"></slot>
        </div>

        <!-- Note -->
        <!-- Keep it one 1 line -->
        <p class="description" v-if="feedback.type == 'note'">{{ feedback.public_description }}</p>

        <!-- Picture -->
        <div v-if="feedback.type == 'picture'">
            <clickable-image :src="feedback.file_src"></clickable-image>
            <p class="description mt-2">{{ feedback.public_description }}</p>
            <p class="description mt-2" v-if="!learner">{{ feedback.confidential_description }}</p>
        </div>

        <!-- Competencies -->
        <badge type="primary" class="mr-1"
                v-for="(competency, index) in feedback.competencies"
                :key="index">
            {{ competency['name_'+lang] }}
        </badge>

        <!-- Recipients -->
        <ul class="text-primary recipients mt-3" v-if="!learner">
            <li v-if="showMe && session && feedback.personal">{{ $t('feedbacks.recipients-me') }}</li>
            <li v-if="feedback.learner1_id">
                <session-recipient :session="session" :feedback="feedback" :degree="registration.degree" :learner="1" :show-positions="showPositions">
                </session-recipient>
            </li>
            <li v-if="feedback.learner2_id">
                <session-recipient :session="session" :feedback="feedback" :degree="registration.degree" :learner="2" :show-positions="showPositions">
                </session-recipient>
            </li>
        </ul>

        <!-- Mark -->
        <base-dropdown v-if="edit && feedback.type == 'mark'">
            <base-button slot="title-container" type="warning" class="dropdown-toggle">
                <i class="fas fa-map-marker-alt mr-1"></i> {{ $t('feedbacks.mark') }}
            </base-button>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createNote')">
                {{ $t('feedbacks.take-note') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createPicture')">
                {{ $t('feedbacks.insert-picture') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('createIssue')">
                {{ $t('issues.add-issue') }}
            </a>
            <a class="dropdown-item" href="#" @click.prevent="$emit('remove', feedback)">
                {{ $t('feedbacks.remove-mark') }}
            </a>
        </base-dropdown>

        <!-- Author -->
        <small class="d-block mt-3 text-primary" v-if="feedback.instructor && showAuthor">
            <em>-- {{ feedback.instructor.name }}</em>
        </small>
    </div>
</template>

<script>
    import SessionRecipient from './SessionRecipient'

    export default {

        components: {
            SessionRecipient
        },

        props: {

            registration: {
                type: Object,
                required: true
            },
            
            simulation: {
                type: Object,
                required: true
            },
            
            session: {
                type: Object,
                default: null
            },

            feedback: {
                type: Object,
                required: true
            },

            lang: {
                type: String,
                required: true
            },

            edit: {
                type: Boolean,
                default: false
            },

            sharing: {
                type: Boolean,
                default: false
            },            

            showAuthor: {
                type: Boolean,
                default: false
            },            

            learner: {
                type: Object,
                default: null
            },

            showMe: {
                type: Boolean,
                default: false
            },

            showPositions: {
                type: Boolean,
                default: false
            },

            preferLearnerSummary: {
                type: Boolean,
                default: false
            },
        },
    }
</script>

<style scoped>

    .description {
        white-space: pre-wrap;
    }
    .actions >>> .btn-group-toggle {
        display: inline-block;
        margin-right: 8px;
        position: relative;
        top: -5px;
    }
    .actions >>> .btn-group-toggle label {
        padding: 0.45rem 0.375rem 0.45rem 0;
        font-size: 0.7rem;
        text-transform: uppercase;
    }
    .recipients {
        font-size: 80%;
        list-style-type: none;
        padding-left: 10px;
        margin-bottom: 0;
        border-left: dashed 1px #7182e4
    }

</style>
